<!-- eslint-disable vue/no-mutating-props -->
<template>
  <t-text-input
    v-if="additional.field.type === 'text'"
    v-model="additional.value"
    :mask="additional.field.mask"
    :label="label"
    :required="additional.field.required"
    :placeholder="additional.field.placeholder"
    density="compact"
    @update:model-value="() => additional.value = additional.value.toString().trim()"
  />
  <t-select
    v-if="additional.field.type === 'select'"
    v-model="additional.value"
    :label="label"
    :required="additional.field.required"
    :placeholder="additional.field.placeholder"
    density="compact"
    :items="sortedOptions"
  />
  <t-date-input
    v-if="additional.field.type === 'timestamp'"
    v-model="additional.value"
    :label="label"
    :required="additional.field.required"
    :placeholder="additional.field.placeholder"
    density="compact"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { AdditionalData } from "@/types/NominalTicket";
import TTextInput from "../core/TTextInput.vue";
import TSelect from "../core/TSelect.vue";
import TDateInput from "../core/TDateInput.vue";

interface Props {
  additional: AdditionalData;
  label?: string;
}

const { additional, label } = defineProps<Props>();

defineOptions({
  name: "AdditionalFieldInput",
});

const sortedOptions = computed<string[]>(() =>
  additional.field.options
    .toSorted((a, b) => a.order - b.order)
    .map(o => o.value),
);
</script>
